import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ThemeInjector from "./ThemeInjector";

export default function AppLayout() {
  return (
    <>
      <ThemeInjector />
      <Navbar />
      <Outlet />
      <Footer />
    </>
  );
}
